import ImgLoader from "./ImgLoader";

export default ImgLoader;